(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-login/assets/javascripts/react/components/media-queries/desktop.js') >= 0) return;  svs.modules.push('/modules/iam-login/assets/javascripts/react/components/media-queries/desktop.js');

'use strict';

const {
  useAtomValue
} = jotai;
const {
  activeMethodAtom
} = svs.iam_login.atoms;
const {
  loginMethods
} = svs.iam_login.constants;
const {
  BankIdMain
} = svs.iam_login.components.bank_id;
const {
  FrejaMain
} = svs.iam_login.components.freja;
const Desktop = () => {
  const activeMethod = useAtomValue(activeMethodAtom);
  return activeMethod === loginMethods.bankid ? React.createElement(BankIdMain, {
    showQR: true
  }) : React.createElement(FrejaMain, {
    showQR: true
  });
};
svs.iam_login.components.media_queries.Desktop = Desktop;

 })(window);